import Request, { SimpleResponse } from './Request';

export interface IYear {
    id: number;
    name: number;
    active: boolean;
}

let _allCache: Promise<IYear[]> | null = null;

export function clearYearCache() {
    _allCache = null;
}

class Year {
    static GetAll = (): Promise<IYear[]> => {
        if (!_allCache) {
            _allCache = Request.DoGet('year/all') as unknown as Promise<IYear[]>;
            _allCache.catch(() => { _allCache = null; });
        }
        return _allCache;
    };
    static Get = (id: number): IYear => { return Request.DoGet('year/' + id) as unknown as IYear; };
    static Update = (id: number, data: IYear): SimpleResponse => {
        _allCache = null;
        return Request.DoPut('year/' + id, data) as unknown as SimpleResponse;
    };
    static Create = (data: IYear): SimpleResponse => {
        _allCache = null;
        return Request.DoPost('year', data) as unknown as SimpleResponse;
    };
    static Delete = (id: number): SimpleResponse => {
        _allCache = null;
        return Request.DoDelete('year/' + id) as unknown as SimpleResponse;
    };
}

export default Year;